import React from 'react';
import cn from 'classnames';
import { FocusScope } from '@react-aria/focus';
import { Button } from '../../button';
import { GridContext, useGrid, useGridCell } from './hooks';
import styles from './styles.module.css';
export function SelectorCell({ value, children, className }) {
    const { ref, onSelect, isFocused, isSelected } = useGridCell({ value });
    return (React.createElement(Button.Simple, { ref: ref, size: "l", className: cn(styles.selectorButton, className), onPress: () => onSelect(value), variant: isSelected ? 'action' : isFocused ? 'default' : 'ghost' }, children));
}
export function Selector(props) {
    const { opened, state, className, renderValue } = props;
    const { keyboardProps, context, containerRef, style } = useGrid(props, state);
    if (!opened)
        return null;
    return (React.createElement(GridContext.Provider, { value: context },
        React.createElement(FocusScope, { restoreFocus: true },
            React.createElement("div", { className: cn(styles.selectorGrid, className), ...keyboardProps, style: style, ref: containerRef }, state.collection.map(value => (React.createElement("div", { key: value, className: styles.gridCell }, renderValue(value))))))));
}
